'use client'

import ReactQueryProvider from '@/globals/providers/ReactQueryProvider'
import { ClerkProvider } from '@clerk/nextjs'
import { TaskMonitorProvider } from '@/contexts/TaskMonitorContext'
import { ReactNode } from 'react'

/**
 * 인증 페이지용 Provider
 * - ClerkProvider 포함
 * - React Query 포함
 * - TaskMonitor 포함
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ReactQueryProvider>
      <ClerkProvider
        publishableKey={process.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY}
      >
        <TaskMonitorProvider>
          {children}
        </TaskMonitorProvider>
      </ClerkProvider>
    </ReactQueryProvider>
  )
}
